/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum BridgeApiConversationStatus {
    OPEN = 'OPEN',
    PENDING = 'PENDING',
    OBSERVING = 'OBSERVING',
    CLOSED = 'CLOSED'
}


export function instanceOfBridgeApiConversationStatus(value: any): boolean {
    for (const key in BridgeApiConversationStatus) {
        if (Object.prototype.hasOwnProperty.call(BridgeApiConversationStatus, key)) {
            if (BridgeApiConversationStatus[key as keyof typeof BridgeApiConversationStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BridgeApiConversationStatusFromJSON(json: any): BridgeApiConversationStatus {
    return BridgeApiConversationStatusFromJSONTyped(json, false);
}

export function BridgeApiConversationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiConversationStatus {
    return json as BridgeApiConversationStatus;
}

export function BridgeApiConversationStatusToJSON(value?: BridgeApiConversationStatus | null): any {
    return value as any;
}

export function BridgeApiConversationStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): BridgeApiConversationStatus {
    return value as BridgeApiConversationStatus;
}

